module.exports = __webpack_public_path__ + "img/teamMember2.0e472cee.webp";